import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  // skills: [],
  data: [],
  isInitialLoading: true,
  error: {},
};

const initialStateforDetails = {
  approveTimeSheetLoading: false,
  loading: false,
  timesheetDetails: [],
  timeSheetApprovalSuccess: false,
  error: {},
  editTimeSheetLoading:false,
};

const initialStateforGraph = {
  loading: false,
  details: [],
  error: {},
};

const TimesheetListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TIMESHEET_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case types.GET_TIMESHEET_LIST_SUCCESS:
      return {
        ...state,
        isInitialLoading: false,
        loading: false,
        data: action.payload?.data,
        error: false,
      };
    case types.GET_TIMESHEET_LIST_FAILURE:
      return {
        ...state,
        isInitialLoading:false,
        loading: false,
        matched: [],
        error: true,
      };
    default:
      return state;
  }
};

export const TimesheetDetailsReducer = (
  state = initialStateforDetails,
  action
) => {
  switch (action.type) {
    case types.GET_TIMESHEET_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case types.GET_TIMESHEET_SUCCESS:
      return {
        ...state,
        loading: false,
        timesheetDetails: action.payload,
        error: false,
      };
    case types.GET_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        timesheetDetails: [],
        error: true,
      };

    // Timesheet Approval Cases
    case types.EDIT_TIMESHEET_REQUESTED:
      return {
        ...state,
        editTimeSheetLoading: true,
        editTimeSheetSuccess: false,
      };
    case types.EDIT_TIMESHEET_SUCCESS:
      return {
        ...state,
        editTimeSheetLoading: false,
        editTimesheetResponse: action.payload,
        editTimeSheetSuccess: true,
        error: false,
      };
    case types.EDIT_TIMESHEET_FAILURE:
      return {
        ...state,
        editTimeSheetLoading: false,
        editTimesheetResponse: [],
        editTimeSheetSuccess: false,
        error: true,
      };
    case types.APPROVE_TIMESHEET_REQUESTED:
      return {
        ...state,
        approveTimeSheetLoading: true,
        timeSheetApprovalSuccess: false,
      };
    case types.APPROVE_TIMESHEET_SUCCESS:
      return {
        ...state,
        approveTimeSheetLoading: false,
        timesheetApprovedResponse: action.payload,
        timeSheetApprovalSuccess: true,
        error: false,
      };
    case types.APPROVE_TIMESHEET_FAILURE:
      return {
        ...state,
        approveTimeSheetLoading: false,
        timesheetApprovedResponse: [],
        timeSheetApprovalSuccess: false,
        error: true,
      };
    // APPROVE _ALLALL
    case types.APPROVE_ALL_TIMESHEET_REQUESTED:
      return {
        ...state,
        approveAllTimeSheetLoading: true,
        allTimeSheetApprovalSuccess: false,
      };
    case types.APPROVE_ALL_TIMESHEET_SUCCESS:
      return {
        ...state,
        approveAllTimeSheetLoading: false,
        allTimesheetApprovedResponse: action.payload,
        allTimeSheetApprovalSuccess: true,
        error: false,
      };
    case types.APPROVE_ALL_TIMESHEET_FAILURE:
      return {
        ...state,
        approveAllTimeSheetLoading: false,
        allTimesheetApprovedResponse: [],
        allTimeSheetApprovalSuccess: false,
        error: true,
      };
    case types.APPROVE_TIME_OFF_REQUESTED:
      return {
        ...state,
        approveTimeOffLoading: true,
        timeOffApprovalSuccess: false,
      };
    case types.APPROVE_TIME_OFF_SUCCESS:
      return {
        ...state,
        approveTimeOffLoading: false,
        timesheetApprovedResponse: action.payload,
        timeOffApprovalSuccess: true,
        error: false,
      };
    case types.APPROVE_TIME_OFF_FAILURE:
      return {
        ...state,
        approveTimeOffLoading: false,
        timesheetApprovedResponse: [],
        timeOffApprovalSuccess: false,
        error: true,
      };

    default:
      return state;
  }
};

export const timesheetGraphReducer = (state = initialStateforGraph, action) => {
  switch (action.type) {
    case types.GET_GRAPH_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case types.GET_GRAPH_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        details: action.payload,
        error: false,
      };
    case types.GET_GRAPH_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        details: [],
        error: true,
      };
    default:
      return state;
  }
};

export default TimesheetListReducer;
